var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{class:_vm.invoicing.icon,attrs:{"title":_vm.invoicing.title}}),_vm._v(" \n  "),_c('i',{class:_vm.shipping.icon,attrs:{"title":_vm.shipping.title}}),_vm._v(" \n  "),_c('i',{class:_vm.delivery.icon,attrs:{"title":_vm.delivery.title}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a8c6fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Orders_v2/Aggregates/WhenTheOrderIs.vue
// module id = j8fG
// module chunks = 0